import placeholderPic from "../assets/image-placeholder.png";

const asObjectURL = (blob_: null | string | Blob): string => {
    if (typeof blob_ === "string") return blob_;

    if (null == blob_) return placeholderPic;

    const blob: Blob & { __dataUrl?: string } = blob_;
    if (typeof blob.__dataUrl === "undefined") blob.__dataUrl = URL.createObjectURL(blob);

    return blob.__dataUrl;
};

export default asObjectURL;
